import isEmpty from '../utility/isEmpty'

export const incomeAmountIsValid = incomeAmountString => {
  if (/[^0-9.,]/g.test(incomeAmountString)) {
    return false
  }

  const rawValue = Number.parseFloat(Number.parseFloat(incomeAmountString.replaceAll(/[^0-9.]/g, '')).toFixed(2))

  if (rawValue < 0.1 || rawValue > 100000) {
    return false
  }

  return true
}

export const incomeIsValid = income => {
  return !isEmpty(income.incomeSource) &&
    ((!income.incomeSource.includes('Employed') && income.incomeSource !== 'Other') || !isEmpty(income.incomeName)) &&
    !isEmpty(income.payFrequency) &&
    !isEmpty(income.lastPayDate) &&
    !isEmpty(income.incomeAmount) &&
    incomeAmountIsValid(income.incomeAmount)
}
